import { useState, useEffect } from 'react';
import { P, cardStyle } from '../styles/theme';
import Btn from './Shared/Btn';
import Badge from './Shared/Badge';
import { fetchErrorLogs, markErrorResolved } from '../services/errorLogService';

const ERROR_TYPE_LABELS = {
  stripe_payment: '💳 Stripe Payment', stripe_refund: '💸 Stripe Refund',
  email: '📧 Email', calendar: '📅 Calendar', backup: '💾 Backup',
  rate_limit: '🚫 Rate Limit', general: '⚠️ General',
};

export default function ErrorLogs() {
  const [logs,         setLogs]         = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [filter, setFilter] = useState('all');

  const loadLogs = async () => {
    setLoading(true);
    try { const data = await fetchErrorLogs(filter, false); setLogs(data); }
    catch {}
    setLoading(false);
  };

  useEffect(() => { loadLogs(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMarkResolved = async (id) => {
    await markErrorResolved(id);
    loadLogs();
  };

  const unresolvedCount = logs.filter(l => !l.resolved).length;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
        <div>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '26px', color: P.deep, fontWeight: 600 }}>Error Logs</h2>
          <p style={{ fontSize: '13px', color: P.muted }}>
            {unresolvedCount > 0
              ? <span style={{ color: P.red, fontWeight: 700 }}>{unresolvedCount} unresolved errors</span>
              : '모든 오류가 처리되었습니다 ✓'}
          </p>
        </div>
        <Btn variant="secondary" size="sm" onClick={loadLogs}>🔄 Refresh</Btn>
      </div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
        {['all','stripe_payment','stripe_refund','email','calendar','backup','rate_limit'].map(type => (
          <button key={type} onClick={() => setFilter(type)}
            style={{ padding: '6px 14px', borderRadius: '20px', border: `1.5px solid ${filter === type ? P.rose : P.border}`, background: filter === type ? P.rose + '18' : 'transparent', color: filter === type ? P.rose : P.muted, cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>
            {type === 'all' ? 'All' : ERROR_TYPE_LABELS[type] || type}
          </button>
        ))}
      </div>
      {loading ? (
        <p style={{ textAlign: 'center', color: P.muted, padding: '40px' }}>Loading...</p>
      ) : logs.length === 0 ? (
        <div style={{ ...cardStyle, textAlign: 'center', padding: '40px' }}>
          <p style={{ fontSize: '32px', marginBottom: '12px' }}>✅</p>
          <p style={{ color: P.muted }}>오류 로그가 없습니다.</p>
        </div>
      ) : logs.map(log => (
        <div key={log.id} style={{ ...cardStyle, borderLeft: `4px solid ${P.red}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', flexWrap: 'wrap' }}>
                <Badge color={P.red}>Unresolved</Badge>
                <span style={{ fontSize: '12px', fontWeight: 700, color: P.deep }}>{ERROR_TYPE_LABELS[log.error_type] || log.error_type}</span>
                <span style={{ fontSize: '11px', color: P.muted }}>{new Date(log.created_at).toLocaleString('en-AU')}</span>
              </div>
              <p style={{ fontSize: '13px', color: P.text, wordBreak: 'break-word', marginBottom: '6px' }}>{log.error_message}</p>
              {log.context && Object.keys(log.context).length > 0 && (
                <p style={{ fontSize: '11px', color: P.muted, fontFamily: 'monospace', background: P.bg, padding: '6px 8px', borderRadius: '6px', wordBreak: 'break-all' }}>
                  {JSON.stringify(log.context)}
                </p>
              )}
            </div>
            <Btn size="sm" variant="secondary" onClick={() => handleMarkResolved(log.id)}>Mark Resolved</Btn>
          </div>
        </div>
      ))}
    </div>
  );
}
